// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--2-hg1";
export var main = "footer-module--main--3tS9z";
export var bottom = "footer-module--bottom--3zg3s";
export var bgImage = "footer-module--bg-image--Pz-VG";
export var icons = "footer-module--icons--2zlIo";